import React,{ useState } from 'react';
import { Modal } from 'react-bootstrap';

const Footer = () => {
  const [aboutModal, setAboutModal] = useState(false);
  const [contactModal, setContactModal] = useState(false);

  const handleClose = () => {
    setAboutModal(false)
    setContactModal(false)
  };
  const handleAbout= () => setAboutModal(true);
  const handleContact = () => setContactModal(true);
 const year = new Date().getFullYear();
  return (
<footer className="footer">
  <div className="container">
    <ul className="nav justify-content-center border-bottom pb-3 mb-3">
      <li className="nav-item">
        <a href='/'  className="nav-link px-2 text-muted">
          الرئيسية
        </a>
      </li>
      <li className="nav-item">
        <button onClick={handleContact} className="nav-link px-2 text-muted">
          تواصل معنا
        </button>
      </li>
      <li className="nav-item">
        <button onClick={handleAbout} className="nav-link px-2 text-muted">
          من نحن
        </button>
      </li>
    </ul>
    <div className="text-center text-muted">
    <p>جميع الحقوق محفوظة &#9400; <span>{year}</span>
    
    </p>

    </div>
  </div>


    {/* about us modal  */}
  <Modal show={aboutModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>من نحن</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>رواد الخبرة للاستشارات الإقتصادية والإدارية والتعليمية الاستثمارية</p>
          <p>أنشئت لخدمتكم وتحقيقا لتطلعاتكم مهتمين بنجاح مشاريعكم وخططكم حيث نعتبر أنفسنا شركاء </p>
        </Modal.Body>
      </Modal>


       {/* cotact modal  */}
  <Modal show={contactModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>تواصل معنا</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <span>تواصل معنا :  </span>
        <a className='text-primary' href="mailto:support@mg.rasedbank.com">support@mg.rasedbank.com</a>
        </Modal.Body>
      </Modal>
</footer>

  );
};



export default Footer;